/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-info-editor.vue?vue&type=template&id=2f640918&"
import script from "./language-info-editor.vue?vue&type=script&lang=js&"
export * from "./language-info-editor.vue?vue&type=script&lang=js&"
import style0 from "./language-info-editor.vue?vue&type=style&index=0&id=2f640918&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports